export class ActionSendPayment {
  static readonly type = "[PAYMENT] ADD PAYMENT";
  constructor(public payload: any) {}
}

export class ResetPayment {
  static readonly type = "[PAYMENT] RESET PAYMENT";
  constructor() {}
}
